module.exports = __webpack_public_path__ + "static/media/github.caf7b92e.svg";